import React from 'react';
import { Avatar } from '@mui/material';
import Chip from 'Components/Chip';
import BasicTable from 'Components/BasicTable';
import { colors } from 'Constants/Colors';
import type { AdminCourseI } from 'types';
import { toRouteTuple } from '../../../Hooks/useCoursesPage';
import { ContainerTable } from './CoursesTable.styled';

const CATEGORY_COLUMN = 3;
const CREATOR_COLUMN = 4;
const CREATOR_PHOTO_INDEX = 5;
// La fila es la tupla legacy (11 posiciones) + el curso tipado al final,
// para recuperar el objeto en el click sin depender de índices frágiles.
const COURSE_INDEX = 11;

export interface CoursesTablePropsI {
  courses: AdminCourseI[];
  colorCategory: Record<string, string>;
  headers: string[];
  loading: boolean;
  onCourseClick: (course: AdminCourseI) => void;
}

export default function CoursesTable({ courses, colorCategory, headers, loading, onCourseClick }: CoursesTablePropsI) {
  const rows = courses.map(course => [...toRouteTuple(course), course]);

  const thereIsComponent = (data: unknown[], index: number): React.ReactNode => {
    if (index === CATEGORY_COLUMN)
      return (
        <Chip style={{ border: 'none', background: `${colorCategory[data[index] as string]}`, color: colors.WHITE }}>
          {null}
          <h4>{data[index] as string}</h4>
        </Chip>
      );
    if (index === CREATOR_COLUMN)
      return (
        <div style={{ display: 'flex' }}>
          <Chip>
            <Avatar alt={data[index] as string} src={data[CREATOR_PHOTO_INDEX] as string} />
            <h4>{data[index] as string}</h4>
          </Chip>
        </div>
      );
    return data[index] as React.ReactNode;
  };

  return (
    <ContainerTable>
      <BasicTable
        information={rows}
        headers={headers}
        limit={5}
        thereIsComponent={thereIsComponent}
        widthColumn="25%"
        clickable
        clickAction={(row: unknown[]) => onCourseClick(row[COURSE_INDEX] as AdminCourseI)}
        isLoading={loading}
      />
    </ContainerTable>
  );
}
